import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../shared/AppSettings';
import { tBedModel } from '../models/tBedModel';
import { tFormMappingModel, NavFormMappingInfoModel, NavFormMappingInfoWithImageModel } from '../models/tFormMappingModel';
import { shareReplay } from 'rxjs/internal/operators/shareReplay';
import { ResultModel } from './tPatient.service';



@Injectable({
    providedIn: 'root'
})

export class tFormMappingService {

    constructor(private http: HttpClient) { }

    baseurl: string = AppSettings.BaseURI;

    readonly pathName = '/FormMapping';

    getAllData() {
        return this.http.get<tFormMappingModel[]>(this.baseurl + this.pathName);
    }

    GetFormMappingInfo(shopID: number, userID: string, roleID: number){
        return this.http.get<NavFormMappingInfoModel[]>(this.baseurl +
             this.pathName +'/FormMappingInfo' + '/' + shopID + '/' + userID + '/' + roleID).pipe(shareReplay(1));
    }

    FormMappingNavigation(shopID: number, roleID: number){
        return this.http.get<NavFormMappingInfoWithImageModel[]>(this.baseurl +
             this.pathName +'/FormMappingNavigation' + '/' + shopID  + '/' + roleID).pipe(shareReplay(1));
    }

    GetFormMappingInfoWithSys(shopID: number, userID: string, roleID: number){
        return this.http.get<NavFormMappingInfoModel[]>(this.baseurl +
             this.pathName +'/FormMappingInfoWithSys' + '/' + shopID + '/' + userID + '/' + roleID).pipe(shareReplay(1));
    }

    GetFormMappingInfoByFormID(shopID: number, userID: string, roleID: number, formID: number){
        return this.http.get<NavFormMappingInfoModel[]>(this.baseurl +
             this.pathName + '/FormMappingInfoByFormID' + '/' + shopID + '/' + userID + '/' + roleID + '/' + formID).pipe(shareReplay(1));
    }


    getDataById(id: string) {
        return this.http.get<tFormMappingModel>(this.baseurl + this.pathName + '/' + id);
    }

    addData(data: tFormMappingModel) {
        return this.http.post(this.baseurl + this.pathName, data);
    }

    deleteData(id: number) {
        return this.http.delete(this.baseurl + this.pathName + '/' + id);
    }

    updateData(data: tFormMappingModel) {
        //   data.lastModifyLoginName = "2";
        return this.http.put(this.baseurl + this.pathName + '/' + data.shopID, data);
    }

    getFormAccessRight(formID:number){
      return this.http.get<ResultModel>(`${this.baseurl + this.pathName}/formAccessRight/${formID}`)
    }
}

export class FormAccessRightModel{
  isAllowAccess:boolean;
  shopID:number;
  formID:number;
}
